/** Web 管理端 MQTT WebSocket 地址（接口文档 §56） */
export const DEFAULT_MQTT_URL = 'wss://hw-base-station.runde.pro/mqtt'

/** 构建 Web 管理端 MQTT WebSocket 连接地址 */
export function buildMqttUrl() {
  return process.env.VUE_APP_MQTT_URL || DEFAULT_MQTT_URL
}
